<template>
  <div class="main-wrapper">
    <sidebar-menu
      width="300px"
      widthCollapsed="50px"
      :menu="menu"
      :relative="true"
      :collapsed="collapsed"
      @update:collapsed="updateCollapsed($event)"
      class="side-menu"
    >
      <template #toggle-icon>
        <v-tooltip location="end" text="開く / 閉じる">
          <template v-slot:activator="{ props }">
            <v-icon v-bind="props" icon="$mdiFormatAlignJustify"></v-icon>
          </template>
        </v-tooltip>
      </template>
    </sidebar-menu>
    <div class="main-container">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import type {
  SidebarComponentItem,
  SidebarHeaderItem,
  SidebarItem,
} from "vue-sidebar-menu";
import { useSideMenu } from "@/composable/side-menu";
import { defineComponent } from "vue";
import type { ContractSummary } from "@/apis/ContractApi";
import type PermissionService from "@/services/PermissionService";
import { mapState } from "vuex";

export default defineComponent({
  name: "OtherMainView",
  setup() {
    const { collapsed, updateCollapsed } = useSideMenu();
    return { collapsed, updateCollapsed };
  },
  computed: {
    ...mapState("user", {
      contractSummary: "contractSummary",
    }),
    menu(): Array<SidebarItem | SidebarComponentItem | SidebarHeaderItem> {
      return getOtherMenus(this.contractSummary, this.$service.permission);
    },
  },
});

export function getOtherMenus(
  contractSummary: ContractSummary,
  permission: PermissionService
): Array<SidebarItem> {
  const isViewDelegate = permission.isViewDelegate();
  return [
    {
      href: "/user",
      title: "ユーザ",
      icon: {
        element: "v-icon",
        attributes: { icon: "$mdiAccountMultipleOutline" },
      },
      hidden: isViewDelegate,
    },
    {
      href: "/notification-contact",
      title: "通知連絡先",
      icon: { element: "v-icon", attributes: { icon: "$mdiEmailOutline" } },
    },
    {
      href: "/download",
      title: "各種ダウンロード",
      icon: { element: "v-icon", attributes: { icon: "$mdiTrayArrowDown" } },
      hidden: !contractSummary.isDownloadList,
    },
  ];
}
</script>
